import { Icon } from '@eventbrite/eds-icon';
import { InfoChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './ShowMore.module.scss';

type ShowMoreVariant = 'default' | 'condensed';

type ShowMoreButtonProps = {
    onToggle: () => void;
    variant?: ShowMoreVariant;
};

type ShowMoreContentProps = {
    isOpen: boolean;
    content: string;
    variant?: ShowMoreVariant;
};

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
    onToggle,
    variant = 'default',
}) => {
    const buttonClass =
        variant === 'condensed'
            ? `${styles.button} ${styles.buttonCondensed}`
            : styles.button;

    return (
        <button
            type="button"
            className={buttonClass}
            onClick={onToggle}
            aria-label={gettext('Show price extra information').toString()}
        >
            <Icon
                className={styles.icon}
                type={<InfoChunky fill="#2D49BE" />}
                width="24px"
                height="24px"
            />
        </button>
    );
};

export const ShowMoreContent: React.FC<ShowMoreContentProps> = ({
    isOpen,
    content,
    variant = 'default',
}) => {
    if (!isOpen) return null;

    const contentClass =
        variant === 'condensed'
            ? `${styles.content} ${styles.contentCondensed} eds-text-bm eds-text-color--ui-600`
            : `${styles.content} eds-text-bm eds-text-color--ui-600`;

    return <p className={contentClass}>{content}</p>;
};
